import { Component, inject, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';


@Component({
  selector: 'app-dialog-confirm',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule
],
  templateUrl: './dialog-confirm.component.html',
  styleUrl: './dialog-confirm.component.scss'
})
export class DialogConfirmComponent {
  data: {message: string, buttonLabel: string, title: string, showSecondaryButton?: boolean, showTertiaryButton?: boolean, tertiaryButtonLabel?: string} = inject(MAT_DIALOG_DATA);

  tertiaryButtonClick = output<void>();

  constructor() {
    if (this.data.showSecondaryButton === undefined) {
      this.data.showSecondaryButton = true;
    }
    if (this.data.showTertiaryButton === undefined) {
      this.data.showTertiaryButton = false;
    }
  }

  onTertiaryButtonClick() {
    this.tertiaryButtonClick.emit();
  }
}
